export {default} from "./SimpleCardList";
